import * as React from 'react'

import { taktId } from '../../../../utils/takt'
import { WidgetTypes } from '../../../../common/constants'
import { useFeatureContext } from '../../../../contexts/FeatureContext'
import { ToggleButton, DotIcon } from '../style'

export const MenuButton: React.FC<{ menuId: string }> = ({ menuId }) => {
  const { featureData, unreadFeatures, featureId, setFeatureIdEvent } = useFeatureContext()
  const featureTaktId = taktId(WidgetTypes.WhatsNewCenterItem, menuId)
  return (
    <ToggleButton active={featureId === menuId} onClick={() => setFeatureIdEvent(menuId)} data-takt-id={`${featureTaktId}_list-button`}>
      {unreadFeatures.includes(menuId) && <DotIcon type="circle" />}
      {featureData[menuId].title}
    </ToggleButton>
  )
}
